module.exports = __webpack_public_path__ + "img/ace_logo.52af1b39.svg";